import { Component, Input } from '@angular/core';

@Component({
	template: require('./landing-promotion.component.html'),
	selector: 'vcm-landing-promotion'
})

export class LandingPromotionComponent {
	@Input() resources: any;
}
